/**
 * Simple health check for HeartBeat provider.
 * Calls the app's health-status API (no auth required).
 */
export async function heartBeat(): Promise<void> {
  const res = await fetch('/api/health-status', { cache: 'no-store' });
  if (!res.ok) {
    throw new Error(`Health check failed: ${res.status}`);
  }
}
